/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc 画像（URL）メッセージ
 *
 * @author genka
 * @copyright Copyright 2019 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<el-card class="fc-image-url-message" :class="[messageClass]">
  <template v-if="link != null">
    <a :href="[link]" target="_blank">
      <img :src="[imageSrc]" class="image" />
      <div class="message-text">{{$t('リンク')}}</div>
    </a>
  </template>
  <template v-else>
    <img :src="[imageSrc]" class="image" />
  </template>
</el-card>
</template>
<script>
import FcMessageUtil from '@/utils/FcMessageUtil'

import {
  Card
} from 'element-ui'

export default {
  name: 'FcImageUrlMessage',
  components: {
    'el-card': Card
  },
  props: [
    /**
     * メッセージ情報
     */
    'messageInfo'
  ],
  data() {
    return {}
  },
  computed: {
    /**
     * メッセージ内容部分に適用するClass（自分のメッセージor他人のメッセージ）を取得します。
     * @return {String} メッセージ内容部分に適用するClass（自分のメッセージor他人のメッセージ）
     */
    messageClass() {
      return 'fc-text-message ' + FcMessageUtil.messageDistributionClass(this.messageInfo)
    },
    /**
     * 画像SRCのURL
     * @return {String}
     */
    imageSrc() {
      const messageOption = JSON.parse(this.messageInfo.messageOption)
      return messageOption.src
    },
    /**
     * リンクのURL
     * @return {String}
     */
    link() {
      const messageOption = JSON.parse(this.messageInfo.messageOption)
      if (messageOption.to != null && messageOption.to.type === 'link') {
        return messageOption.to.url
      }
      return null
    }
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/chatWindow/chatMain/message/FcImageUrlMessage.vue